/*
 * @Description: 项目中心
 * @Date: 2025-03-19 13:35:06
 */
import { route } from './src/router';

const name = 'project-center';
export { name, route };
